/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuickBaselineSessionDto
 */
export interface QuickBaselineSessionDto {
    /**
     * 
     * @type {string}
     * @memberof QuickBaselineSessionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof QuickBaselineSessionDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuickBaselineSessionDto
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuickBaselineSessionDto
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof QuickBaselineSessionDto
     */
    scoringVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof QuickBaselineSessionDto
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof QuickBaselineSessionDto
     */
    answerCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof QuickBaselineSessionDto
     */
    completedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof QuickBaselineSessionDto
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the QuickBaselineSessionDto interface.
 */
export function instanceOfQuickBaselineSessionDto(value: object): value is QuickBaselineSessionDto {
    return true;
}

export function QuickBaselineSessionDtoFromJSON(json: any): QuickBaselineSessionDto {
    return QuickBaselineSessionDtoFromJSONTyped(json, false);
}

export function QuickBaselineSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuickBaselineSessionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'scoringVersion': json['scoringVersion'] == null ? undefined : json['scoringVersion'],
        'status': json['status'] == null ? undefined : json['status'],
        'answerCount': json['answerCount'] == null ? undefined : json['answerCount'],
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function QuickBaselineSessionDtoToJSON(json: any): QuickBaselineSessionDto {
    return QuickBaselineSessionDtoToJSONTyped(json, false);
}

export function QuickBaselineSessionDtoToJSONTyped(value?: QuickBaselineSessionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'profileId': value['profileId'],
        'frameworkSlug': value['frameworkSlug'],
        'scoringVersion': value['scoringVersion'],
        'status': value['status'],
        'answerCount': value['answerCount'],
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt']).toISOString()),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

